module.exports = __webpack_public_path__ + "static/media/fabric_0001.4111c99f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrics/fabric_0001.jpg
// module id = 627
// module chunks = 0